<template>
	<div class="row">
		<div class="col-sm-12 col-md-4">
			<div class="chat-window">
				<div class="chat-header">
					<h2>Chat Room</h2> 
				</div>
				<div class="chat-rooms">
					<div class="accordion" v-if="!loading"> 
                        <div class="accordion-item" v-for="(item, index) in items" :key="index" >
                          <div  class="accordion-header" @click="activeItemIndex = index" >
                            {{ item.product_name }}  
                          </div>
                          <div  class="accordion-content" v-if="activeItemIndex === index" > 
								<div class="message" v-for="(room, key) in item.product_group" :key="room.id">
									<ul>
										<li >
											<a href="#" @click="myRooms(room.id, key)">{{ room.account }} || {{ room.user }} || {{  room.id }}</a> 
										</li>
									</ul> 
								</div>  
                          </div>
                        </div>
                      </div>
				</div>
			</div>
		</div>
		<div class="col-sm-12 col-md-8">
			<div class="chat-window " :style="{ height: windowHeight + 'px' }">
				<div class="chat-header">
					<h2 v-if="active_group">{{ active_group.product  ? active_group.product.name + '-' + active_group.order_id : ''}} 
						{{ active_group.account_assign ? active_group.account_assign.user.name : ''}}</h2>
				</div>

				<div class="chat-messages chat-container" @scroll="onScroll" ref="chatMessages" id="chatMessages">
					<div class="message" v-for="message in messages" :key="message.id"
						:class="{ 'message-right': message.sender_id == userData.user.id, 'message-left': message.sender_id != userData.user.id }">
						<p v-if="message.user" class="user-info">{{ message.user ? message.user.name : '' }}</p>
						<p v-if="message.content" class="message">{{ message.content }}</p>
						<div v-if="message.image" class="thumbnail"><br> <br>
							<img :src="message.image" v-if="message.image" class="thumbnail-img" width="150"
								@click="openPopupImage(message.image)" />
						</div>

					</div>
				</div>

				<div class="chat-footer">
					<input v-model="newMessage" type="text" @keyup.enter="sendMessage" placeholder="Type a message...">
					<input type="file" ref="fileInput" @change="uploadImage" />
					<button @click="sendMessage">Send</button>
					<!-- <button @click="sendCredentials">Send credentials</button> -->
				</div>
			</div>
		</div>
		<Modal @close="toggleModal()" :modalActive="modalActive">
			<div class="modal-content scrollbar-width-thin">
				<div class="modal-header">
					<h4>Image Preview</h4>
					<button @click="toggleModal()" type="button" class="btn btn-default">
						X
					</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<img class="mess_image_pre" v-if="popupImageLink" :src="popupImageLink" />
						</div>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>
 
<script>
import Modal from "./../helper/Modal.vue";
import axios from 'axios';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { mapGetters, mapActions } from "vuex"; 
export default {
	components: {
		Modal,
	},
	data() {
		return {
			newMessage: '',
			fileMessage: '',
			fileName: '',
			messages: [],
			rooms: [],
			items: [],
			activeItemIndex: null,
			messageText: '',
			currentLogedinUser: 2,
			windowHeight: 0,
			active_group: {},
			current_page: 1,
			last_page: 0,
			on_scroll_controll: false,
			scroll_top: 0,
			pusher: null,
			chatChannel: null,
			channel: null,
			reachedBottom: false,
			thumbnailPreview: '',
			modalActive: false,
			popupImageLink: '',
			dataLoaded: false
		};
	},
	methods: {
		toggleModal: function () {
			this.modalActive = !this.modalActive;
			if (!this.modalActive) {
				this.popupImageLink = '';
			}
		},
		openPopupImage: function (item) {
			this.popupImageLink = item;
			this.toggleModal();
		},
		async fetchMessages(room_id) {
			this.on_scroll_controll = true;
			await axios.get(this.apiUrl + '/messages/' + room_id + '?page=' + this.current_page, this.headers)
				.then((response) => {
					if (response.status == 200) {
						this.messages = this.messages.concat(response.data.data)
						this.current_page = response.data.current_page;
						this.last_page = response.data.last_page;
						this.on_scroll_controll = false;
					} else {
						this.$toast.error(response.data.message);
					}
				});
		},
		myRooms(room_id, key=null) {
			// console.log('room_id', room_id)
			// console.log('key', key)
			// console.log('this.rooms', this.rooms)
			// console.log('this.rooms', this.rooms[room_id])
			this.current_page = 1;
			this.last_page = 1;
			this.on_scroll_controll = false;
			this.active_group = this.rooms ? this.rooms[room_id] : '';
			this.fetchMessages(room_id);
			this.messages = [];
		}, 
		// sendCredentials() {
		// 	axios.post(this.apiUrl + "/messages", {
		// 		message: 'Account Name: ' + this.active_group.account + ' Password: ' + this.active_group.ac_password,
		// 		account_group_id: this.active_group.id
		// 	}, this.headers).then(() => {
		// 		this.current_page = 1;
		// 		this.messages = [];
		// 		this.fetchMessages(this.active_group.id);
		// 		this.scrollToBottom();
		// 	});
		// },
		sendMessage() {
			//this.channel.trigger('chat-channel'); 
			const formData = new FormData();
			formData.append('thumbnail', this.fileName);
			formData.append('message', this.newMessage);
			formData.append('account_group_id', this.active_group.id);

			var postEvent = axios.post(
				this.apiUrl + "/messages",
				formData,
				this.headers
			);
			postEvent.then(() => {
				this.current_page = 1;
				this.messages = [];
				this.fetchMessages(this.active_group.id);
				this.newMessage = '';
				this.thumbnail = '';
				this.fileName = '';
				this.scrollToBottom();
			});
			this.newMessage = '';
		},
		async fetchItems() { 
            await axios.get(this.apiUrl+'/product-group', this.headerjson)
            .then((res) => {
                this.items = res.data.data;
				// this.dataLoaded = true;
            })
            .catch((err) => {
                this.$toast.error(err);
            });
        },

		listenForNewMessages() {
			 
		},
		async getAccountGroup() {
			await axios.get(this.apiUrl + "/chat-group", this.headers)
				.then((res) => {
					if (res.status == 200) {
						this.rooms = res.data.data;
						// console.log('this.rooms.length',JSON.stringify(this.rooms))
						if(this.rooms.length > 0){
							// for (let index = 0; index < 1; index++) {
							// 	this.active_group = this.rooms[index]; 
							// 	console.log('ddddddddddddddddddddd',this.rooms[index])
							// }		
							
						}				
						// console.log('this.items', this.active_group)
						this.fetchMessages(this.active_group.id);
					} else {
						this.$toast.error(res.data.message);
					}
				});
		},
		getWindowHeight() {
			this.windowHeight = window.innerHeight - 60;
		},
		scrollToBottom() {
			const chatMessages = this.$refs.chatMessages;
			chatMessages.scrollTop = chatMessages.scrollHeight;

		},
		setupEcho() {
			this.echo = new Echo({
				broadcaster: 'pusher',
				key: '16fc597b27f0f561b848',
				cluster: 'ap2',
				encrypted: true,
				auth: this.headerjson,
			});
			this.chatChannel = this.echo.private('chat-channel');
			this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
				cluster: process.env.VUE_APP_PUSHER_CLUSTER,
				encrypted: true,
			});
		},
		onScroll() {
			const el = this.$refs.chatMessages;
			if ((Math.abs(el.scrollTop) >= (Math.abs(el.clientHeight - el.scrollHeight) - 5)) && (this.current_page <= this.last_page) && (!this.on_scroll_controll)) {
				this.current_page++;
				this.fetchMessages(this.active_group.id);
			}
		},
		// onImageChange(e) {
		// 	this.form.thumbnail = e.target.files[0];
		// 	let files = e.target.files || e.dataTransfer.files;
		// 	if (!files.length) return;
		// 	this.createImage(files[0]);
		// },
		createImage(file) {
			let reader = new FileReader();
			let vm = this;
			reader.onload = (e) => {
				vm.thumbnailPreview = e.target.result;
			};
			reader.readAsDataURL(file);
		},
		async uploadImage() {
			const file = this.$refs.fileInput.files[0];
			this.fileName = file;
			this.createImage(file);
		}
	},
	async created() {
		this.getAccountGroup();
		this.fetchItems();
	},
	beforeDestroy() {
		this.pusher.unsubscribe('chat-channel');
	},
	async  mounted() {
		// await this.fetchItems();
		// if (this.dataLoaded) {
		// 	const itemId = this.$route.params.id;
		// if (itemId) {
		// 	this.myRooms(itemId);
		// }
		// }
		this.getWindowHeight();
		window.addEventListener("resize", this.getWindowHeight);
		// this.fetchMessages(this.active_group.id);
		// this.listenForNewMessages();
		//this.scrollToBottom();
		
		setInterval(() => {
			const el = this.$refs.chatMessages;  
			if(( this.active_group) && (this.active_group.id) && (el.scrollTop > -1)){	
				this.messages = [];
				this.fetchMessages(this.active_group.id);
			}
		}, 15000); 
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.getWindowHeight);
	},
	// updated(() => {
    //   //console.log('onUpdated')
    //   //console.log(document.getElementById('count').textContent)
    // }),
	computed: {
		// canLoadMore() {
		// 	return this.messages.length < 10; //this.totalMessages;
		// },
		...mapGetters(["userData"]),
		computedClass() {
			if (this.currentRouteName == "/pos") {
				return "active";
			} else {
				return "";
			}
		},
		currentRouteName() {
			return this.$route.path;
		},
	},
};
</script>
	 
<style scoped>
.mess_image_pre{
	width: 100%;
	height: 100%;
}
.modal-content.scrollbar-width-thin {
	border: none !important;
	width: 600px;
}

.thumbnail-img {
	cursor: pointer
}

.chat-window {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow-y: auto;
}

.chat-header {
	background-color: #1976d2;
	color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
}

.chat-messages {
	flex-grow: 1;
	padding: 16px;
	overflow-y: scroll;
	flex-direction: column-reverse;
	display: flex;
	margin-bottom: 36px;
}

.message {
	background-color: #f8f9fa;
	border-radius: 4px;
	padding: 8px;
	margin-bottom: 8px;
}

.chat-footer {
	display: flex;
	align-items: center;
	padding: 8px;
	background-color: #f8f9fa;
	border-top: 1px solid #e1e4e8;
	position: fixed;
	bottom: 0;
	width: 50%;
	background-color: #f1f1f1;
	box-sizing: border-box;
	right: 3%;
}

input[type="text"] {
	flex-grow: 1;
	padding: 8px;
	border: 1px solid #e1e4e8;
	border-radius: 4px;
	margin-right: 8px;
}

button {
	background-color: #1976d2;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 16px;
	cursor: pointer;
}

ul {
	list-style: none;
	/* removes default bullet points */
	padding: 0;
	/* removes default padding */
	margin: 0;
	/* removes default margin */
}

.message-right {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 10px;
	position: relative;
}

.message-right .message-text {
	background-color: #007bff;
	color: #fff;
	border-radius: 5px;
	padding: 10px;
}

.message-left {
	display: flex;
	justify-content: flex-start;
	margin-bottom: 10px;
	position: relative;
}

.message-left .message-text {
	background-color: #f2f2f2;
	color: #333;
	border-radius: 5px;
	padding: 10px;
}

.message-right .user-info {
	padding: 19px 2px -1px 0px;
	margin: -8px 3px 0px 0px;
	position: absolute;
	padding: 0px 2px;
}

.message-left .user-info {
	padding: 19px 2px -1px 0px;
	margin: -8px 3px 0px 0px;
	position: absolute;
	padding: 0px 2px;
}
 
.accordion {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.accordion-item {
  border-bottom: 1px solid #ccc;
}

.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
}
.accordion-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
  border-top: 1px solid blue;
  padding: 10px;
}

.accordion-icon {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
}

.accordion-icon.active {
  transform: rotate(180deg);
}

.accordion-content {
  padding: 10px;
}
</style>
 